import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import PropTypes from 'prop-types';

export default class DropBoxSelector extends React.Component {
  render() {
    const {
      label,
      value,
      onSelect,
      options,
      width = 160,
      error,
      bold = false,
    } = this.props;

    const dropdownStyle = {
      width,
      height: 40,
    };

    if (error) {
      dropdownStyle.borderColor = 'red';
    }

    return (
      <div className="DropBoxSelector">
        {/* CSS LOCAL – só afeta este componente */}
        <style>
          {`
            /* Input fechado do Dropdown */
            .tele-dropdown .p-dropdown-label {
              font-size: 14px !important;
              padding: 6px 10px !important;
              height: 40px !important;
              display: flex;
              align-items: center;
              ${bold ? 'font-weight: bold !important;' : ''}
            }

            /* Botão da setinha */
            .tele-dropdown .p-dropdown-trigger {
              width: 32px !important;
            }

            /* Painel com as opções (lista) */
            .tele-dropdown-panel .p-dropdown-item {
              font-size: 14px !important;
              padding: 4px 10px !important;
              ${bold ? 'font-weight: bold !important;' : ''}
            }

            .tele-dropdown-panel .p-dropdown-items {
              padding: 4px 0 !important;
            }

            .tele-dropdown-panel {
              z-index: 20000 !important;
            }

            /* Label flutuante */
            .tele-dropdown-label {
              top: -0.75em;
              font-size: 12px;
              ${bold ? 'font-weight: bold !important;' : ''}
            }
          `}
        </style>

        <span className="p-float-label">
          <Dropdown
            inputId="operation-dropdown"
            value={value}
            options={options}
            onChange={(e) => onSelect(e.value)}
            style={dropdownStyle}
            className="tele-dropdown"
            panelClassName="tele-dropdown-panel"
            filter={true}
            filterPlaceholder="Buscar..."
          />
          <label className="tele-dropdown-label">{label}</label>
        </span>
      </div>
    );
  }
}

DropBoxSelector.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  onSelect: PropTypes.func,
  options: PropTypes.array,
  width: PropTypes.number,
  error: PropTypes.bool,
  bold: PropTypes.bool,
};
